module.exports = __webpack_public_path__ + "img/confirm.adc143b6.png";